import type { Product } from "../hooks/useProducts";

/** Must match `InventoryBulkUploadController::sample()` in the API. */
export const INVENTORY_BULK_HEADERS = [
  "brand",
  "categories",
  "cost_price",
  "expiry_date",
  "mrp",
  "product_name",
  "quantity",
  "selling_price",
  "sku",
] as const;

function escapeCsvCell(value: string): string {
  if (value.includes('"')) {
    value = value.replace(/"/g, '""');
  }
  if (/[",\n\r]/.test(value)) {
    return `"${value}"`;
  }
  return value;
}

function brandNameForProduct(p: Product, brandIdToName: Map<string, string>): string {
  if (!p.brand_id) return "";
  return brandIdToName.get(String(p.brand_id)) ?? "";
}

/**
 * Build CSV rows compatible with `/api/inventory/bulk/validate` (same columns as sample download).
 */
export function productsToInventoryBulkRows(
  products: Product[],
  brandIdToName: Map<string, string>,
): string[][] {
  return products.map((p) => {
    const categories = (p.categories ?? []).map((c) => c.name).join(", ");
    const ab = p.pos_active_batch;
    return [
      brandNameForProduct(p, brandIdToName),
      categories,
      ab?.purchase_price ?? "",
      "",
      ab?.mrp ?? "",
      p.name,
      p.available_qty_net != null && p.available_qty_net !== "" ? String(p.available_qty_net) : "0",
      ab?.selling_price ?? "",
      p.sku ?? "",
    ];
  });
}

export function buildInventoryBulkCsv(rows: string[][]): string {
  const headerLine = INVENTORY_BULK_HEADERS.map(escapeCsvCell).join(",");
  const dataLines = rows.map((cells) => cells.map(escapeCsvCell).join(","));
  return [headerLine, ...dataLines].join("\r\n");
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
